export function positiveIntegerSearch(value: unknown): number | undefined {
  if (typeof value === "number") {
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
  }
  if (typeof value !== "string") {
    return undefined;
  }
  // TanStack Router previously serialized string-valued filters as JSON strings,
  // so keep old copied/bookmarked URLs (clientId=%22147%22) readable while every
  // new navigation writes the canonical numeric form.
  const normalized = /^"[1-9]\d*"$/.test(value) ? value.slice(1, -1) : value;
  if (!/^[1-9]\d*$/.test(normalized)) return undefined;
  const parsed = Number(normalized);
  return Number.isSafeInteger(parsed) ? parsed : undefined;
}
